import { ReactNode } from 'react';

export const CardLayoutGrid = ({ children }: { children: ReactNode }) => {
  return <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-6 lg:grid-cols-4 xl:grid-cols-5">{children}</div>;
};
